module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/p2C-cta@2x.ed8e71b4.jpg";